export default "__VITE_ASSET__1DGqAJGw__"